var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "container-nav px-0 shadow-sm float-left",
          class: _vm.getCurrentProductTypeClass
        },
        [
          _c(
            "div",
            { staticClass: "sub-nav sub-nav-rc1 float-left" },
            [
              _vm._l(_vm.navigationItems(), function(navItem, key) {
                return [
                  _vm.checkTabDispCond(navItem)
                    ? _c(
                        "button",
                        {
                          key: key,
                          class: navItem.buttonStyles,
                          attrs: { title: navItem.itemTitle, tabindex: "0" },
                          on: {
                            keydown: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.goToRoute(navItem)
                            },
                            click: function($event) {
                              return _vm.goToRoute(navItem)
                            }
                          }
                        },
                        [
                          navItem.status === "ActiveIncomplete" ||
                          navItem.status === "InactiveIncomplete"
                            ? _c(
                                "span",
                                { staticClass: "fa-stack uniform-icon-size" },
                                [
                                  _c("span", {
                                    staticClass: "fas fa-circle fa-stack-2x",
                                    class: _vm.iconColor(navItem)
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass:
                                      "fas fa-exclamation fa-stack-1x",
                                    staticStyle: { color: "#fff" }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          navItem.status !== "InactiveIncomplete" &&
                          navItem.status !== "ActiveIncomplete" &&
                          navItem.status !== "ActiveFirstTime" &&
                          navItem.status !== "InactiveFirstTime" &&
                          navItem.status !== "Disabled"
                            ? _c(
                                "span",
                                { staticClass: "fa-stack uniform-icon-size" },
                                [
                                  _c("span", {
                                    staticClass: "fas fa-circle fa-stack-2x",
                                    class: _vm.iconColor(navItem)
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "fas fa-check fa-stack-1x",
                                    staticStyle: { color: "#fff" }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          navItem.itemIcon
                            ? _c(
                                "span",
                                { staticClass: "fa-stack uniform-icon-size" },
                                [_c("span", { class: _vm.iconStyles(navItem) })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "navi-btn-label" }, [
                            _vm._v(_vm._s(navItem.label))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _vm.flowType === "bundle" ||
      _vm.flowType === "cabundle" ||
      _vm.flowType === "rabundle"
        ? _c("Breadcrumbs", { attrs: { navData: _vm.pageData } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8eed8f62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8eed8f62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/widgets/SectionNavigation.vue
// module id = null
// module chunks = 